// Restores the reservation in progress once the whole page has hydrated (async layouts and pages
// included), so the server HTML and the first client render agree. Changes made in another tab
// come in through the storage event.
export default defineNuxtPlugin(nuxtApp => {
  const { restore } = useShoppingBag()
  nuxtApp.hooks.hookOnce('app:suspense:resolve', restore)
  window.addEventListener('storage', event => {
    if (event.key === 'shopping-bag') { restore() }
  })
})
